"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var CONTAINER_MAX_WIDTH = 1220;
exports.Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-bottom: 4px solid ", ";\n  color: ", "; \n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  padding: 0 ", ";\n  width: auto;\n  \n  .Footer__innerWrapper {\n    margin: 0 auto;\n    max-width: ", "px;\n    padding: ", " 0 ", ";\n    width: 100%;\n  }\n"], ["\n  background-color: ", ";\n  border-bottom: 4px solid ", ";\n  color: ", "; \n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  padding: 0 ", ";\n  width: auto;\n  \n  .Footer__innerWrapper {\n    margin: 0 auto;\n    max-width: ", "px;\n    padding: ", " 0 ", ";\n    width: 100%;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s200;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.main.base;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s700;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.text.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.text.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.text.fontWeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.body.text.lineHeight;
}, function (_a) {
    var theme = _a.theme;
    return theme.space.s300;
}, CONTAINER_MAX_WIDTH, function (_a) {
    var theme = _a.theme;
    return theme.space.s400;
}, function (_a) {
    var theme = _a.theme;
    return theme.space.s300;
});
exports.Wrapper.displayName = 'VPFooterWrapper';
var templateObject_1;
